<template>
  <h1 class="page-title">Relatório</h1>

  <div class="action-panel">
    <MultiSelect
      id="columns-selected"
      v-model="search.columns"
      :options="options"
      @update="updateColumns"
    >
      <template #selection>
        {{ search.columns.length }} coluna(s) selecionada(s)
      </template>
    </MultiSelect>

    <button title="Exportar Excel" @click="downloadExcel()" class="action-text">
      <span>Exportar Excel</span>
      <img alt="Exportar tabela Excel" src="../../assets/svg/download.svg" />
    </button>
  </div>

  <Table
    :columns="columns"
    :rows="rows"
    :pagination="pagination"
    @update="updateSearch"
    :multiple-filters="true"
    :loading="loading"
    ref="Table"
  >
    <template #item-row="props">
      <template v-if="props.item.field === 'name'">
        <a @click="resumeStudent(props.item.row.id)" class="action">
          {{ props.item.row.name }}
        </a>
      </template>
      <template v-if="props.item.field === 'action'">
        <div class="buttons">
          <button
            title="Visualizar documento"
            @click="resumeStudent(props.item.row.id)"
            class="action"
          >
            <img
              alt="Visualizar dados"
              src="../../assets/svg/lupa_action.svg"
            />
          </button>
        </div>
      </template>
    </template>
  </Table>
</template>

<script>
import { RecordTable } from "../../services";
import MultiSelect from "../MultiSelect.vue";
import Table from "../DefaultTable/Table.vue";
import TableManagement from "../../components/DefaultTable/TableManagement";


export default {
  name: "Record",

  components: {
    MultiSelect,
    Table,
  },

  data() {
    return {
      // Service usado para obtenção dos dados
      service: RecordTable,

      /* Variáveis padrões da tabela */
      // Dados
      columns: [],
      rows: [],

      // Filtros
      search: {
        columns: [],
        order_by: "name",
        order_direction: "0",
        page: "1",
        pagesize: 5,
        where: {},
      },

      // Paginação
      pagination: {
        currentPage: 1,
        lastPage: 1,
        itemsPerPage: 5,
        count: null,
      },
      /* Variáveis padrões da tabela */

      // Variáveis do multiselect
      options: [],
      selected: [],

      loading: false,
    };
  },

  async created() {
    TableManagement.new();

    TableManagement.addColumn({
      label: "Ações",
      field: "action",
      onDisplay: true,
      filterOptions: {
        enabled: false,
      },
    });

    // Personalizando largura da coluna "Nome"
    TableManagement.customizeColumn("name", { textwrap: "nowrap" });
    // Personalizando largura da coluna "Nome da IES"
    TableManagement.customizeColumn("nome_ies", { textwrap: "nowrap" });
    // Personalizando largura da coluna "Nome da mãe"
    TableManagement.customizeColumn("nome_mae", { textwrap: "nowrap" });
    // Personalizando largura da coluna "Nome do pai"
    TableManagement.customizeColumn("nome_pai", { textwrap: "nowrap" });
    // Personalizando largura da coluna "Nome do pai"
    TableManagement.customizeColumn("endereco", {
      textwrap: "nowrap",
      truncate: true,
      truncateLimit: 35,
    });
    // Personalizando largura da coluna "Nome do pai"
    TableManagement.customizeColumn("identidade", {
      textwrap: "nowrap",
      truncate: true,
      truncateLimit: 35,
    });

    // Configuração das colunas.
    const { columns, columnsKey } = await TableManagement.getColumns(
      this.service
    );
    this.columns = columns;
    this.search.columns = columnsKey;

    // Configura as opções para o multiselect
    // this.options = this.createOptions(this.columns, "label", "field");

    // Obtém os dados iniciais da pesquisa.
    await this.updateData();
  },

  methods: {
    /**
     * Cria as opções que serão inseridas no Multiselect.
     * Componente: Multiselect.vue
     * @function
     * @returns {Array}
     */
    createOptions(array, labelName, keyName) {
      return array.map((item) => {
        return { label: item[labelName], key: item[keyName] };
      });
    },

    /**
     * Atualiza as colunas exibidas.
     * Componente: Multiselect.vue
     * @function
     * @returns {void}
     */
    updateColumns() {
      this.columns.forEach((column) => {
        column.onDisplay = this.search.columns.includes(column.field);
      });

      this.updateData();
    },

    /**
     * Atualiza as informações do objeto usado para requisitar os dados.
     * Componente: Table.vue
     * @function
     * @returns {void}
     */
    updateSearch(mode, data) {
      switch (mode) {
        case "filters":
          this.search.where = data;
          this.search.page = 1;
          break;
        case "pagination":
          this.search.page = data.currentPage;
          this.search.pagesize = data.itemsPerPage;
          break;
      }

      this.updateData();
    },

    /**
     * Realiza a requisição e a atualização dos dados com base nos novos filtros.
     * Componente: Table.vue
     * @function
     * @async
     * @returns {void}
     */
    async updateData() {
      this.loading = true;
      const response = await TableManagement.searchData(
        this.service,
        this.search
      );

      // Atualiza as linhas da tabela
      this.rows = response.result;

      // Atualiza as informações da paginação
      this.pagination = {
        currentPage: response.current_page,
        lastPage: response.lastpage,
        itemsPerPage: response.per_page,
        count: response.count,
      };

      this.loading = false;
    },
    // teste
    resumeStudent(id) {
      this.$router.push("/profile/" + id);
    },

    async downloadExcel() {
      const data = await TableManagement.searchData(
        this.service,
        this.search,
        true
      );

      await TableManagement.downloadExcel("Relatório", "Dados", data.result);
    },
  },
};
</script>
